"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SheetMusicSongProps", {
  enumerable: true,
  get: function get() {
    return _types.sheetMusicSongProps;
  }
});
exports.default = void 0;

var _vue = require("vue");

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _alert = _interopRequireDefault(require("ant-design-vue/lib/alert"));

require("ant-design-vue/lib/alert/style/index.css");

var _spin = _interopRequireDefault(require("ant-design-vue/lib/spin"));

require("ant-design-vue/lib/spin/style/index.css");

var _lodash = _interopRequireDefault(require("lodash"));

var _playScoreResult = _interopRequireDefault(require("./playScoreResult"));

var _playScoreShow = _interopRequireDefault(require("./playScoreShow"));

var _playerControlBoard = _interopRequireDefault(require("./playerControlBoard"));

var _useGesture2 = _interopRequireDefault(require("../hooks/useGesture"));

var _useMediaTool2 = _interopRequireDefault(require("./hooks/useMediaTool"));

var _usePlayScore2 = _interopRequireDefault(require("./hooks/usePlayScore"));

var _usePlaySound2 = _interopRequireDefault(require("./hooks/usePlaySound"));

var _useRenderSheet2 = _interopRequireDefault(require("./hooks/useRenderSheet"));

var _playback = _interopRequireDefault(require("./playback"));

var _types = require("./types");

var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

/**
 * 1. 渲染曲谱
 * 2. 下载音频
 * 3. 初始化数据
 */
var SheetMusicSong = (0, _vue.defineComponent)({
  name: 'SheetMusicSong',
  components: {
    Spin: _spin.default,
    PlayerControlBoard: _playerControlBoard.default,
    PlayScoreShow: _playScoreShow.default,
    PlayScoreResult: _playScoreResult.default,
    Playback: _playback.default
  },
  props: _types.sheetMusicSongProps,
  emits: ['error', 'success', 'audioCacheError', 'audioCacheSuccess'],
  setup: function setup(props, ctx) {
    var _this = this;

    var sheetMusicContainer = (0, _vue.ref)();
    var sheetMusicSongRef = (0, _vue.ref)();
    var sheetMusicSongPlayBack = (0, _vue.ref)();
    (0, _vue.provide)('sheetMusicSongRef', sheetMusicSongRef);
    var isPresetting = (0, _vue.ref)(props.isPreset);
    var onUploadRecordScore = (props === null || props === void 0 ? void 0 : props.onUploadRecordScore) || undefined; // 评分录音上传回调函数

    var loadObj = (0, _vue.reactive)({
      loadingText: '设置曲谱中...',
      loading: false,
      loadingTip: '设置曲谱中...',
      reset: function reset() {
        this.loadingTip = this.loadingText;
      }
    });
    var alertTips = (0, _vue.reactive)({
      show: false,
      showIcon: true,
      type: 'warning',
      message: '',
      reset: function reset() {
        // this.show = false;
        this.type = 'warning';
        this.message = '';
      },
      showMessage: function showMessage(type, message) {
        var showIcon = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
        this.show = true;
        this.type = type;
        this.message = message;
        this.showIcon = showIcon;
      },
      hideMessage: function hideMessage() {
        this.show = false;
      }
    });
    var rePlaySheetMusicSongProps = (0, _vue.computed)(function () {
      return {
        song: props.song,
        svgApi: props.svgApi,
        loadSheetMode: props.loadSheetMode,
        sheetOption: props.sheetOption
      };
    });
    var backgroundStyle = (0, _vue.ref)(''); // 背景样式

    var playControlBoardStyle = (0, _vue.ref)(''); // 播放控制样式

    var _useRenderSheet = (0, _useRenderSheet2.default)(props),
        sheetMusicEl = _useRenderSheet.sheetMusicEl,
        loadSheetResult = _useRenderSheet.loadSheetResult,
        sheetMusicBusiness = _useRenderSheet.sheetMusicBusiness,
        setBusinessOptions = _useRenderSheet.setBusinessOptions,
        renderSheet = _useRenderSheet.renderSheet,
        destroySheet = _useRenderSheet.destroySheet;

    var _useMediaTool = (0, _useMediaTool2.default)(),
        userVolume = _useMediaTool.userVolume,
        accVolume = _useMediaTool.accVolume,
        userDelay = _useMediaTool.userDelay,
        mixerDuration = _useMediaTool.mixerDuration,
        currentMixerTime = _useMediaTool.currentMixerTime,
        playAudioMixerState = _useMediaTool.playAudioMixerState,
        isAudioMixerPlaying = _useMediaTool.isAudioMixerPlaying,
        setCurrentMixerTime = _useMediaTool.setCurrentMixerTime,
        initMediaMixer = _useMediaTool.initMediaMixer,
        destroyMediaMixer = _useMediaTool.destroyMediaMixer,
        destroyMediaGenerator = _useMediaTool.destroyMediaGenerator,
        handleMergeSound = _useMediaTool.handleMergeSound;

    var _usePlayScore = (0, _usePlayScore2.default)(props, sheetMusicBusiness, loadObj, alertTips, initMediaMixer, destroyMediaMixer),
        userDeviceOk = _usePlayScore.userDeviceOk,
        recordResultVisible = _usePlayScore.recordResultVisible,
        recordReplayVisible = _usePlayScore.recordReplayVisible,
        playScoreParams = _usePlayScore.playScoreParams,
        recordScore = _usePlayScore.recordScore,
        recordUserAudio = _usePlayScore.recordUserAudio,
        recordAccAudio = _usePlayScore.recordAccAudio,
        recordResultAudio = _usePlayScore.recordResultAudio,
        recordUploadData = _usePlayScore.recordUploadData,
        recordEndInfo = _usePlayScore.recordEndInfo,
        recordScoreResultRealTime = _usePlayScore.recordScoreResultRealTime,
        initPlayScore = _usePlayScore.initPlayScore,
        destroyPlayScore = _usePlayScore.destroyPlayScore,
        setPlayScorePlayState = _usePlayScore.setPlayScorePlayState,
        getStartRecordInfo = _usePlayScore.getStartRecordInfo,
        getEndRecordInfo = _usePlayScore.getEndRecordInfo,
        openReplay = _usePlayScore.openReplay,
        changePlayScoreLoading = _usePlayScore.changePlayScoreLoading,
        setIsRecordScoreing = _usePlayScore.setIsRecordScoreing,
        recordReplayJson = _usePlayScore.recordReplayJson,
        canShowPlayScore = _usePlayScore.canShowPlayScore;

    var _usePlaySound = (0, _usePlaySound2.default)(props, loadObj, isPresetting, alertTips, sheetMusicBusiness, sheetMusicEl, playScoreParams, initPlayScore, setIsRecordScoreing),
        playParms = _usePlaySound.playParms,
        closeAreaRange = _usePlaySound.closeAreaRange,
        currentTime = _usePlaySound.currentTime,
        duration = _usePlaySound.duration,
        playMode = _usePlaySound.playMode,
        playModes = _usePlaySound.playModes,
        playState = _usePlaySound.playState,
        isPlaying = _usePlaySound.isPlaying,
        isCanPlay = _usePlaySound.isCanPlay,
        isAreaSelectCurrent = _usePlaySound.isAreaSelectCurrent,
        ABErrorTips = _usePlaySound.ABErrorTips,
        preFetchAudioOK = _usePlaySound.preFetchAudioOK,
        preReadyTime = _usePlaySound.preReadyTime,
        startTime = _usePlaySound.startTime,
        dragStartTime = _usePlaySound.dragStartTime,
        getRange = _usePlaySound.getRange,
        playerOptions = _usePlaySound.playerOptions,
        pluginOptions = _usePlaySound.pluginOptions,
        fetchMp3 = _usePlaySound.fetchMp3,
        initPlayParms = _usePlaySound.initPlayParms,
        initPlayMode = _usePlaySound.initPlayMode,
        stopPlay = _usePlaySound.stopPlay,
        setIsPlayScore = _usePlaySound.setIsPlayScore,
        showColvinMeodly = _usePlaySound.showColvinMeodly,
        destroyMp3 = _usePlaySound.destroyMp3;

    var preScale = (0, _vue.ref)();
    var curScale = (0, _vue.ref)(1);
    var gestureScale = (0, _vue.ref)(1);

    var _useGesture = (0, _useGesture2.default)(sheetMusicContainer, {
      gesturestart: function gesturestart() {
        if (!props.enableGesture) {
          return;
        }

        preScale.value = curScale.value;
      },
      gesturechange: function gesturechange(e) {
        var _a;

        if (!props.enableGesture) {
          return;
        }

        console.log('gesturechange', e);
        gestureScale.value = e.scale;

        if (playParms.fullSheet) {
          return;
        }

        curScale.value = gestureScale.value * preScale.value;

        if (curScale.value > 1) {
          curScale.value = 1;
        } else if (curScale.value < 0.5) {
          curScale.value = 0.5;
        }

        (_a = sheetMusicBusiness.value) === null || _a === void 0 ? void 0 : _a.scaleTo(curScale.value);
      }
    }),
        initGestureEvent = _useGesture.initGestureEvent,
        destroyGestureEvent = _useGesture.destroyGestureEvent;

    var checkSheetFileUrl = function checkSheetFileUrl() {
      return new Promise(function (resolve, reject) {
        var _a;

        if (!((_a = props.song) === null || _a === void 0 ? void 0 : _a.evxmlFileUrl)) {
          loadSheetResult.value = false;
          console.warn('没有曲谱文件');
          reject(new Error('没有曲谱文件'));
        }

        resolve();
      });
    };

    var cacheMp3 = function cacheMp3() {
      return fetchMp3().then(function () {
        ctx.emit('audioCacheSuccess', 'audio缓存成功');
      }).catch(function () {
        ctx.emit('audioCacheError', {
          audioCanPlay: false,
          preFetchAudioOK: true // 为了不提示

        });
      });
    }; // 更新背景配置


    var changeBackground = function changeBackground(background) {
      var _ref = background || {},
          color = _ref.color,
          imageUrl = _ref.imageUrl;

      if (imageUrl && !imageUrl.includes('singplay-bg1.')) {
        // singplay-bg1 实际为当前默认底图
        backgroundStyle.value = "background-size:100% 100%;background-image:url(".concat(imageUrl, ")");
        playControlBoardStyle.value = "background:rgba(255,255,255,0.3);box-shadow: 0px -5px 10px rgba(0, 0, 0, 0.1);";
      } else if (color) {
        backgroundStyle.value = "background:".concat(color);
        playControlBoardStyle.value = "background:rgba(255,255,255,0.3);box-shadow: 0px -5px 10px rgba(0, 0, 0, 0.1);";
      } else {
        backgroundStyle.value = '';
        playControlBoardStyle.value = '';
      }
    }; // 更新旋律线配置


    var changeMelodyConfig = function changeMelodyConfig(colvinMelody, oldColvinMelody) {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, isChanged, _ref2, melodyLineColor, melodyLineWidth, melodyLineImage, melodyImageWidth, _ref3, oldMelodyLineColor, oldMelodyLineWidth, oldMelodyLineImage, oldMelodyImageWidth;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                isChanged = false;
                _ref2 = colvinMelody || {}, melodyLineColor = _ref2.melodyLineColor, melodyLineWidth = _ref2.melodyLineWidth, melodyLineImage = _ref2.melodyLineImage, melodyImageWidth = _ref2.melodyImageWidth;
                _ref3 = oldColvinMelody || {}, oldMelodyLineColor = _ref3.melodyLineColor, oldMelodyLineWidth = _ref3.melodyLineWidth, oldMelodyLineImage = _ref3.melodyLineImage, oldMelodyImageWidth = _ref3.melodyImageWidth;

                if (melodyLineColor && melodyLineColor !== oldMelodyLineColor) {
                  (_b = (_a = sheetMusicBusiness.value) === null || _a === void 0 ? void 0 : _a.plugin.$colvinMelodyRender) === null || _b === void 0 ? void 0 : _b.setMelodyLineColor(melodyLineColor);
                  isChanged = true;
                }

                if (melodyLineWidth && melodyLineWidth !== (oldMelodyLineWidth || 3)) {
                  (_d = (_c = sheetMusicBusiness.value) === null || _c === void 0 ? void 0 : _c.plugin.$colvinMelodyRender) === null || _d === void 0 ? void 0 : _d.setMelodyLineWidth(melodyLineWidth + '');
                  isChanged = true;
                }

                if (melodyLineImage !== oldMelodyLineImage) {
                  (_f = (_e = sheetMusicBusiness.value) === null || _e === void 0 ? void 0 : _e.plugin.$colvinMelodyRender) === null || _f === void 0 ? void 0 : _f.setMelodyLineImage(melodyLineImage);
                  isChanged = true;
                }

                if (melodyImageWidth && melodyImageWidth !== (oldMelodyImageWidth || 110)) {
                  (_h = (_g = sheetMusicBusiness.value) === null || _g === void 0 ? void 0 : _g.plugin.$colvinMelodyRender) === null || _h === void 0 ? void 0 : _h.setMelodyImageWidth(melodyImageWidth);
                  isChanged = true;
                }

                if (!(isChanged && !isPresetting.value)) {
                  _context.next = 11;
                  break;
                }

                showColvinMeodly(playParms.colvin, playParms.meodly);
                _context.next = 11;
                return (_j = sheetMusicBusiness.value) === null || _j === void 0 ? void 0 : _j.refreshSheet();

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    }; // 监听外部传入的动作


    (0, _vue.watch)(function () {
      return _lodash.default.cloneDeep(props.action);
    }, function (newVal) {
      var type = newVal.type;

      if (type === _types.PlayState.stop) {
        playState.value = _types.PlayState.stop;
      }
    }); // 评分相关，获取当前播放状态和所需评分数据

    (0, _vue.watch)(function () {
      return playState.value;
    }, function (newVal) {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var _startTime;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(newVal === _types.PlayState.start)) {
                  _context2.next = 4;
                  break;
                }

                getStartRecordInfo(playMode.value, playParms.speed, _lodash.default.cloneDeep(getRange()));
                _context2.next = 9;
                break;

              case 4:
                if (!(newVal === _types.PlayState.stop)) {
                  _context2.next = 9;
                  break;
                }

                _startTime = playParms.isPreReadyTime ? preReadyTime.value : startTime.value;

                if (preReadyTime.value === startTime.value) {
                  // （ 为开始的曲谱，从头播放两者时间一致
                  _startTime = 0;
                }

                _context2.next = 9;
                return getEndRecordInfo(playParms.displayMode, playMode.value, playParms.speed, playParms.keySignature, playParms.isPreReadyTime, _startTime, playParms.url);

              case 9:
                setPlayScorePlayState(playState.value);

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    });
    (0, _vue.watch)(function () {
      return [playMode, playParms, playScoreParams, closeAreaRange];
    }, _lodash.default.debounce(function (newVal) {
      var _a;

      var _b = newVal[1],
          accFileBuffer = _b.accFileBuffer,
          oriFileBuffer = _b.oriFileBuffer,
          sheetInfo = _b.sheetInfo,
          song = _b.song,
          url = _b.url,
          partInfo = _b.partInfo,
          sourceSpeed = _b.sourceSpeed,
          sourceKeySignature = _b.sourceKeySignature,
          _playParams = __rest(_b, ["accFileBuffer", "oriFileBuffer", "sheetInfo", "song", "url", "partInfo", "sourceSpeed", "sourceKeySignature"]);

      var singPlayParamsEvent = new CustomEvent(_types.PreviewParamsEvent.SING_PLAY_PARAMS_CHANGE, {
        detail: {
          playMode: playMode.value,
          playParams: (0, _extends2.default)((0, _extends2.default)({}, _playParams), {
            partInfo: (0, _vue.toRaw)(partInfo)
          }),
          playScoreParams: (0, _vue.toRaw)(newVal[2]),
          closeAreaRange: ((_a = newVal[1]) === null || _a === void 0 ? void 0 : _a.closeAreaSelection) ? (0, _vue.toRaw)(closeAreaRange.value) : undefined
        }
      });
      window.dispatchEvent(singPlayParamsEvent);
    }, 300), {
      deep: true
    });
    (0, _vue.watch)(function () {
      return [playParms.colvin, playParms.meodly];
    }, function (_ref4) {
      var _ref5 = (0, _slicedToArray2.default)(_ref4, 2),
          colvin = _ref5[0],
          melody = _ref5[1];

      if ((colvin || melody) && playScoreParams.pitchBar) {
        // 开启科尔文手势或者旋律线关闭音高条
        playScoreParams.pitchBar = false;
      }
    });
    (0, _vue.watch)(function () {
      return playScoreParams.score;
    }, function (newVal) {
      setIsPlayScore(newVal);

      if (!newVal && playScoreParams.pitchBar) {
        // 关闭评分且音高条为开启状态,关闭音高条
        playScoreParams.pitchBar = false;
      }
    });
    (0, _vue.watch)(function () {
      return playScoreParams.pitchBar;
    }, function (newVal) {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // await enablePitchBar(newVal);
                if (newVal) {
                  // 开启音高条关闭科尔文手势和旋律线
                  if (playParms.colvin) {
                    playParms.colvin = false;
                  }

                  if (playParms.meodly) {
                    playParms.meodly = false;
                  }
                }

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
    });
    /**
     * 监听曲谱背景配置，更新背景
     */

    (0, _vue.watch)(function () {
      var _a;

      return (_a = props.songConfig) === null || _a === void 0 ? void 0 : _a.background;
    }, function () {
      var _a, _b;

      ((_a = props.songConfig) === null || _a === void 0 ? void 0 : _a.background) && changeBackground((_b = props.songConfig) === null || _b === void 0 ? void 0 : _b.background);
    }, {
      deep: true,
      immediate: true
    });
    /**
     * 监听旋律线相关配置，更新旋律线
     */

    (0, _vue.watch)(function () {
      var _a, _b;

      return (_b = (_a = props.sheetOption) === null || _a === void 0 ? void 0 : _a.pluginConfig) === null || _b === void 0 ? void 0 : _b.colvinMelody;
    }, function (newVal, oldVal) {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee4() {
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (_lodash.default.isEqual(newVal, oldVal)) {
                  _context4.next = 3;
                  break;
                }

                _context4.next = 3;
                return changeMelodyConfig(newVal, oldVal);

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
    }, {
      deep: true
    });
    (0, _vue.watch)(function () {
      var _a;

      return (_a = sheetMusicBusiness.value) === null || _a === void 0 ? void 0 : _a.plugin;
    }, function () {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee5() {
        var _k, _l, _m, _o;

        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!((_l = (_k = sheetMusicBusiness.value) === null || _k === void 0 ? void 0 : _k.plugin) === null || _l === void 0 ? void 0 : _l.$colvinMelodyRender)) {
                  _context5.next = 3;
                  break;
                }

                _context5.next = 3;
                return changeMelodyConfig((_o = (_m = props.sheetOption) === null || _m === void 0 ? void 0 : _m.pluginConfig) === null || _o === void 0 ? void 0 : _o.colvinMelody, {});

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));
    }, {
      immediate: true
    });
    (0, _vue.onMounted)(function () {
      loadObj.loading = true;
      checkSheetFileUrl().then(function () {
        return setBusinessOptions({
          playerOptions: playerOptions(),
          pluginOptions: pluginOptions()
        });
      }).then(renderSheet).then(initGestureEvent).then(initPlayParms).then(function () {
        //! 这边其实有问题的，因为只是渲染曲谱的话，播放按钮时不能点击的，但是因为场景时在ppt编辑，所以不会有点击事件
        if (props.renderSheetOnly) {
          return new Promise(function () {
            //fixme 默认预下载成功，不然下载不成功的提示会显示出来
            preFetchAudioOK.oriAudioOk.result = true;
            ctx.emit('success', '曲谱加载成功');
            loadObj.loading = false;
          });
        } else {
          return true;
        }
      }).then(function () {
        loadObj.loading = false;
        loadObj.reset();
      }).then(cacheMp3).then(initPlayMode) // 等曲谱渲染完成从localStorage中读取曲谱显示方式并修改
      .then(readDisplayMode).then(function () {
        ctx.emit('success', '曲谱加载成功');
      }).catch(function (e) {
        ctx.emit('error', e.message);
      });
    });
    (0, _vue.onBeforeUnmount)(function () {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee6() {
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                destroyPlayScore();
                _context6.next = 3;
                return destroySheet();

              case 3:
                destroyGestureEvent();
                destroyMp3();
                destroyMediaGenerator();

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));
    });

    var readDisplayMode = function readDisplayMode() {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee7() {
        var _p, mode;

        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                mode = localStorage.getItem('displayMode');
                console.log('mode', mode);

                if (!mode) {
                  _context7.next = 8;
                  break;
                }

                playParms.displayMode = _lodash.default.parseInt(mode);
                _context7.next = 6;
                return (_p = sheetMusicBusiness.value) === null || _p === void 0 ? void 0 : _p.setDisplayMode(+mode);

              case 6:
                _context7.next = 9;
                break;

              case 8:
                playParms.displayMode = 0;

              case 9:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));
    };

    return {
      userDeviceOk: userDeviceOk,
      canShowPlayScore: canShowPlayScore,
      sheetMusicContainer: sheetMusicContainer,
      sheetMusicSongRef: sheetMusicSongRef,
      sheetMusicSongPlayBack: sheetMusicSongPlayBack,
      loadObj: loadObj,
      sheetMusicEl: sheetMusicEl,
      playParms: playParms,
      playScoreParams: playScoreParams,
      recordScore: recordScore,
      playMode: playMode,
      playModes: playModes,
      duration: duration,
      playState: playState,
      currentTime: currentTime,
      isPlaying: isPlaying,
      isCanPlay: isCanPlay,
      isAreaSelectCurrent: isAreaSelectCurrent,
      ABErrorTips: ABErrorTips,
      alertTips: alertTips,
      dragStartTime: dragStartTime,
      recordResultVisible: recordResultVisible,
      recordReplayVisible: recordReplayVisible,
      recordUserAudio: recordUserAudio,
      recordAccAudio: recordAccAudio,
      recordUploadData: recordUploadData,
      recordResultAudio: recordResultAudio,
      rePlaySheetMusicSongProps: rePlaySheetMusicSongProps,
      recordEndInfo: recordEndInfo,
      recordScoreResultRealTime: recordScoreResultRealTime,
      stopPlay: stopPlay,
      openReplay: openReplay,
      onUploadRecordScore: onUploadRecordScore,
      changePlayScoreLoading: changePlayScoreLoading,
      recordReplayJson: recordReplayJson,
      userVolume: userVolume,
      accVolume: accVolume,
      userDelay: userDelay,
      mixerDuration: mixerDuration,
      currentMixerTime: currentMixerTime,
      playAudioMixerState: playAudioMixerState,
      isAudioMixerPlaying: isAudioMixerPlaying,
      setCurrentMixerTime: setCurrentMixerTime,
      handleMergeSound: handleMergeSound,
      backgroundStyle: backgroundStyle,
      playControlBoardStyle: playControlBoardStyle
    };
  },
  render: function render() {
    var _this2 = this;

    return (0, _vue.createVNode)("div", {
      "class": "sheet-music-song",
      "id": "sheetMusicSong",
      "ref": "sheetMusicSongRef"
    }, [(0, _vue.createVNode)(_spin.default, {
      "spinning": this.loadObj.loading,
      "size": "large",
      "tip": this.loadObj.loadingTip,
      "indicator": function indicator() {
        return (0, _vue.h)('span');
      }
    }, {
      default: function _default() {
        return [_this2.recordReplayVisible && (0, _vue.createVNode)(_playback.default, {
          "ref": "sheetMusicSongPlayBack",
          "changePlayScoreLoading": _this2.changePlayScoreLoading,
          "sheetProps": _this2.rePlaySheetMusicSongProps,
          "replayPlayParams": _this2.recordEndInfo,
          "recordResultAudio": _this2.recordResultAudio,
          "recordReplayJson": _this2.recordReplayJson,
          "recordScoreResultRealTime": _this2.recordScoreResultRealTime,
          "eurFileUrl": _this2.recordUploadData.eur_file_url,
          "recordReplayVisible": _this2.recordReplayVisible,
          "onUpdate:recordReplayVisible": function onUpdateRecordReplayVisible($event) {
            return _this2.recordReplayVisible = $event;
          },
          "playMode": _this2.playMode
        }, null), _this2.recordResultVisible && (0, _vue.createVNode)(_playScoreResult.default, {
          "playMode": _this2.playMode,
          "recordScore": _this2.recordScore,
          "userDelay": _this2.userDelay,
          "onUpdate:userDelay": function onUpdateUserDelay($event) {
            return _this2.userDelay = $event;
          },
          "userVolume": _this2.userVolume,
          "onUpdate:userVolume": function onUpdateUserVolume($event) {
            return _this2.userVolume = $event;
          },
          "accVolume": _this2.accVolume,
          "onUpdate:accVolume": function onUpdateAccVolume($event) {
            return _this2.accVolume = $event;
          },
          "playAudioMixerState": _this2.playAudioMixerState,
          "onUpdate:playAudioMixerState": function onUpdatePlayAudioMixerState($event) {
            return _this2.playAudioMixerState = $event;
          },
          "recordReplayVisible": _this2.recordReplayVisible,
          "onUpdate:recordReplayVisible": function onUpdateRecordReplayVisible($event) {
            return _this2.recordReplayVisible = $event;
          },
          "recordResultVisible": _this2.recordResultVisible,
          "onUpdate:recordResultVisible": function onUpdateRecordResultVisible($event) {
            return _this2.recordResultVisible = $event;
          },
          "currentTime": _this2.currentMixerTime,
          "duration": _this2.mixerDuration,
          "setCurrentMixerTime": _this2.setCurrentMixerTime,
          "handleMergeSound": _this2.handleMergeSound,
          "changePlayScoreLoading": _this2.changePlayScoreLoading,
          "openReplay": _this2.openReplay,
          "recordUploadData": _this2.recordUploadData,
          "onUploadRecordScore": _this2.onUploadRecordScore,
          "replayPlayParams": _this2.recordEndInfo
        }, null), (0, _vue.createVNode)("div", {
          "class": "sheet-music-container",
          "ref": "sheetMusicContainer",
          "style": _this2.backgroundStyle
        }, [_this2.userDeviceOk && _this2.playScoreParams.score && (0, _vue.createVNode)(_playScoreShow.default, {
          "score": _this2.playScoreParams.score,
          "onUpdate:score": function onUpdateScore($event) {
            return _this2.playScoreParams.score = $event;
          },
          "totalScore": _this2.recordScore.totalScore
        }, null), (0, _vue.createVNode)("div", {
          "id": "paper",
          "ref": "sheetMusicEl"
        }, null)]), (0, _vue.createVNode)("div", {
          "class": "player-control-board-contianer",
          "style": _this2.playControlBoardStyle
        }, [(0, _vue.createVNode)(_playerControlBoard.default, {
          "playModes": _this2.playModes,
          "duration": _this2.duration,
          "currentTime": _this2.currentTime,
          "platform": _this2.platform,
          "isCanPlay": _this2.isCanPlay,
          "isPlaying": _this2.isPlaying,
          "userDeviceOk": _this2.userDeviceOk,
          "isAreaSelectCanPlay": !_this2.playParms.closeAreaSelection || _this2.playParms.closeAreaSelection && _this2.isAreaSelectCurrent,
          "playParms": _this2.playParms,
          "onUpdate:playParms": function onUpdatePlayParms($event) {
            return _this2.playParms = $event;
          },
          "playMode": _this2.playMode,
          "onUpdate:playMode": function onUpdatePlayMode($event) {
            return _this2.playMode = $event;
          },
          "playState": _this2.playState,
          "onUpdate:playState": function onUpdatePlayState($event) {
            return _this2.playState = $event;
          },
          "dragStartTime": _this2.dragStartTime,
          "onUpdate:dragStartTime": function onUpdateDragStartTime($event) {
            return _this2.dragStartTime = $event;
          },
          "playScoreParams": _this2.playScoreParams,
          "onUpdate:playScoreParams": function onUpdatePlayScoreParams($event) {
            return _this2.playScoreParams = $event;
          },
          "alertTips": _this2.alertTips,
          "canShowPlayScore": _this2.canShowPlayScore
        }, null)]), _this2.ABErrorTips && (0, _vue.createVNode)("div", {
          "class": "show-error-tips"
        }, [(0, _vue.createVNode)("div", {
          "class": "show-error-tips-icon"
        }, null), (0, _vue.createVNode)("div", {
          "class": "show-error-tips-text"
        }, [_this2.ABErrorTips])]), _this2.alertTips.show && (0, _vue.createVNode)("div", {
          "class": "alert-tips"
        }, [(0, _vue.createVNode)(_alert.default, _this2.alertTips, null)])];
      }
    })]);
  }
});

SheetMusicSong.install = function (app) {
  app.component(SheetMusicSong.name, SheetMusicSong);
  return app;
};

var _default2 = SheetMusicSong;
exports.default = _default2;